import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/chengrengaokao', label: '成人高考' },
  { path: '/category/zixuekaoshi', label: '自学考试' },
  { path: '/category/wangluojiaoyu', label: '网络教育' },
  { path: '/category/guojiakaifang', label: '国家开放大学' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="font-heading text-2xl text-primary-600 whitespace-nowrap">
              成人高清
            </span>
            <span className="hidden sm:inline text-sm text-foreground-600 whitespace-nowrap">
              学历提升平台
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:4008889999"
              className="flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              <span>400-888-9999</span>
            </a>
            <Link
              to="/about"
              className="px-4 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              免费咨询
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200/70 pt-3 mt-2">
              <a
                href="tel:4008889999"
                className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-600 cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </a>
              <Link
                to="/about"
                className="block mx-3 mt-2 px-4 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium text-center hover:bg-primary-600 transition-colors cursor-pointer"
              >
                免费咨询
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}